const actionsScope = 'CIRCLES/ACTIONS';

export const CIRCLE_ACTION_TYPES = {
  INVITE_TO_FAMILY_CIRCLE: `${actionsScope}/INVITE_TO_FAMILY_CIRCLE`,
  CHANGE_ROLE: `${actionsScope}/CHANGE_ROLE`,
  REMOVE_MEMBER: `${actionsScope}/REMOVE_MEMBER`,
  LEAVE_CIRCLE: `${actionsScope}/LEAVE_CIRCLE`,
  ASSIGN_ROLE: `${actionsScope}/ASSIGN_ROLE`,
};



// WEBPACK FOOTER //
// ./src/redux/circles/constants.js